module.exports = __webpack_public_path__ + "static/media/escribli_logo_white.5fda1ea7.svg";